import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpEvent,
  HttpErrorResponse,
  HttpEventType,
} from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "@env";

@Injectable({
  providedIn: "root",
})
export class FileUploadService {
  constructor(private http: HttpClient) {}

  upload(formData) {
    return this.http
      .post<any>(
        `${environment.apiUrl}StudentInfo/AddAssignmentAttachmentsOfStudent`,
        formData,
        {
          reportProgress: true,
          observe: "events",
        }
      )
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }

  attemptupload(assignmentid, name, filename, filesize) {
    return this.http
      .post(
        `${environment.apiUrl}StudentInfo/AttemptAssignmentAttachmentsOfStudent`,
        { assignmentid, name, filename, filesize }
      )
      .subscribe(
        (ret) => {
          //
        },
        (err) => console.log(err)
      );
  }

  private getEventMessage(event: HttpEvent<any>, formData) {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        return this.fileUploadProgress(event);
        break;
      case HttpEventType.Response:
        return this.apiResponse(event);
        break;
      default:
        return `File "${
          formData.get("profile").name
        }" surprising upload event: ${event.type}.`;
    }
  }

  private fileUploadProgress(event) {
    const percentDone = Math.round((100 * event.loaded) / event.total);
    return { status: "progress", message: percentDone };
  }

  private apiResponse(event) {
    return event.body;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    console.log(error);
    return throwError("Something bad happened. Please try again later.");
  }
}
